module.exports = __webpack_public_path__ + "static/media/gym4.d37fe5e1.jpg";